export const buildProductDetailPath = ({
  productId,
  variantId,
  colorId,
  sizeId,
  imageUrl,
}) => {
  const params = new URLSearchParams();

  if (variantId) params.set('variant', String(variantId));
  if (colorId) params.set('color', String(colorId));
  if (sizeId) params.set('size', String(sizeId));
  if (imageUrl) params.set('image', imageUrl);

  const query = params.toString();
  return `/buyer/product/${productId}${query ? `?${query}` : ''}`;
};

export const parseProductSelectionState = (search = '') => {
  const params = new URLSearchParams(search.startsWith('?') ? search.slice(1) : search);

  return {
    variantId: params.get('variant') || '',
    colorId: params.get('color') || '',
    sizeId: params.get('size') || '',
    imageUrl: params.get('image') || '',
  };
};

export const resolveInitialVariant = ({
  variants = [],
  selectionState = null,
  canAddToCart = true,
}) => {
  const normalizedVariants = Array.isArray(variants) ? variants : [];
  const availableVariants = canAddToCart
    ? normalizedVariants.filter((variant) => variant?.is_active !== false && variant?.sold_out === false)
    : normalizedVariants;

  if (availableVariants.length === 0) {
    return {
      selectedVariant: null,
      selectedColor: '',
      selectedSize: '',
      selectedImageUrl: '',
    };
  }

  const requestedVariantId = selectionState?.variantId;
  const requestedColorId = selectionState?.colorId;
  const requestedSizeId = selectionState?.sizeId;
  const requestedImageUrl = selectionState?.imageUrl || '';

  const preferredVariant = requestedVariantId
    ? availableVariants.find((variant) => String(variant?.id) === String(requestedVariantId))
    : null;

  const matchedByColorSize = !preferredVariant && (requestedColorId || requestedSizeId)
    ? availableVariants.find((variant) => {
        const colorMatches = requestedColorId ? String(variant?.color_id) === String(requestedColorId) : true;
        const sizeMatches = requestedSizeId ? String(variant?.size_id) === String(requestedSizeId) : true;
        return colorMatches && sizeMatches;
      })
    : null;

  const initialVariant = preferredVariant || matchedByColorSize || availableVariants[0] || null;

  return {
    selectedVariant: initialVariant,
    selectedColor: initialVariant?.color_id || requestedColorId || '',
    selectedSize: initialVariant?.size_id || requestedSizeId || '',
    selectedImageUrl: requestedImageUrl,
  };
};
